// Roles. Needs to be the same as backend app/Models/Role.php (Laravel)
export const ROLES_INVESTOR = "investor";
export const ROLES_ADMIN = "admin";
export const ROLES_ADVISOR = "advisor";
